import { Controller } from '@hotwired/stimulus'

// Connects to the data-controller="send-message"
export default class extends Controller {
  static targets = ['form', 'input', 'button']

  connect() {
    this.formTarget.addEventListener('turbo:submit-end', () => this.enableButton())
    this.buttonTarget.addEventListener('click', (event) => this.send(event))
  }

  send(event) {
    event.preventDefault()
    this.processSubmit()
  }

  sendOnKeyup(event) {
    if ((event.ctrlKey || event.metaKey) && event.key === 'Enter')
      this.processSubmit()
  }

  processSubmit() {
    this.isValid()
      ? this.submit()
      : this.inputTarget.focus()
  }

  submit() {
    this.disableButton()
    this.trimInput()
    this.formTarget.requestSubmit()
    this.inputTarget.value = ''
    this.inputTarget.focus()
    this.element.dispatchEvent(new Event('send-message:send', { bubbles: true }))
  }

  isValid() {
    return !!this.inputTarget.value.trim()
  }

  trimInput() {
    this.inputTarget.value = this.inputTarget.value.trim()
  }

  disableButton() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = true
  }

  enableButton() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = false
  }
}
